import axios from "axios";
import toast from "react-hot-toast";

const apiUrl = "https://kulabox.co.ke/api/";




// API Routes
const LOGIN = "login";
const GET_VENDOR_TYPES = "vendor/types";
const GET_BANNERS = "banners";
const GET_VENDORS = "vendors";
const GET_CATEGORIES_BY_VENDOR_TYPE_ID = "categories";
const GET_PRODUCTS = "products";
const UPDATE_USER = "update_user";
const GET_ADDRESS = "delivery/addresses";
const ADD_ADDRESS = "add_address";
const DELETE_ADDRESS = "delete_address";
const UPDATE_ADDRESS = "update_address";
const GET_ORDERS = "orders"
const SEARCH = "search"
const COUPONS = "coupons"
const PLACEORDER = "orders"

// Helper function to get the user data from local storage
const getUser = () => {
  let user = localStorage.getItem("user");
  if (user) {
    try {
      return JSON.parse(user);
    } catch (error) {
      console.error("Failed to parse user data:", error);
      return {};
    }
  }
  return {};
};



axios.interceptors.request.use(
  async function (config) {
    if (config.url.includes("/sanctum/csrf-cookie")) {
      return config;
    }

    const user = getUser();
    const token = user?.token || null;
    config.url = `${apiUrl}${config.url}`;

    if (token) {
      Object.assign(config.headers, {
        Authorization: `Bearer ${token}`,
      });
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);



// Axios interceptor for handling responses
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);


async function getCsrfToken() {
  try {

    await axios.get("https://kulabox.co.ke/sanctum/csrf-cookie", {
      withCredentials: true,
    });
  } catch (error) {
    console.error("Error while setting CSRF token:", error);
    throw error;
  }
}

function handleUnauthorizedAccess() {
  toast.error("Unauthorized access. Please log in again.");
  setTimeout(() => {
    localStorage.clear();
    localStorage.removeItem("user");
    window.location.href = "/";
  }, 2000);
}

const getToken = () => {
  const token = localStorage.getItem("token");
  return token ? JSON.parse(token) : null;
};


export const get_vendor_types = async () => {
  let response = await axios.get(GET_VENDOR_TYPES);
  return response.data;
};

// API call to get banners
export const get_banners = async () => {
  let response = await axios.get(GET_BANNERS);
  return response.data;
};

// API call to get vendors
export const get_vendors = async () => {
  let response = await axios.get(GET_VENDORS);
  return response.data;
};


export const get_vendors_by_id = async (id) => {
  let response = axios.get(`${GET_VENDORS}/${id}`) 
  return response;
};

// API call to get categories by vendor type
export const get_categories_by_vendor_type = async () => {
  let vendor_type_id = localStorage.getItem("vendor_type_id");
  let response = await axios.get(GET_CATEGORIES_BY_VENDOR_TYPE_ID, {
    params: { vendor_type_id },
  });
  return response.data;
};

// API call to get products
export const get_products = async () => {
  let vendor_type_id = localStorage.getItem("vendor_type_id");
  let response = await axios.get(GET_PRODUCTS, {
    params: { vendor_type_id },
  });
  return response.data;
};

export const get_products_by_vendor_id = async (vendorId) => {
  let response = await axios.get(GET_PRODUCTS, {
    params: { "vendor_id":vendorId },
  });
  return response.data;
};

// Function to log in the user
export async function login_user(email, password) {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);

  try {
    await getCsrfToken();
    let response = await axios.post(LOGIN, formData, {
      withCredentials: true,
      credentials: 'include',
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });
    return response;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
}

const getLatLang = () => {
  let geolatitude = localStorage.getItem("latitude");
  let geolongitude = localStorage.getItem("longitude");

  return { latitude: geolatitude, longitude: geolongitude };
};

//update user
export const update_user = async (
  username = "",
  mobile = "",
  email = "",
  image = "",
  address = "",
  city_id = "",
  referral_code = ""
) => {
  let { id: user_id } = getUser();
  let location = getLatLang();
  const formData = new FormData();
  formData.append("user_id", user_id);
  formData.append("username", username);
  formData.append("mobile", mobile);
  formData.append("email", email);
  formData.append("image", image);
  formData.append("address", address);
  if (typeof location != "undefined") {
    if (typeof location.latitude != "undefined") {
      formData.append("latitude", location.latitude);
    }
    if (typeof location.longitude != "undefined") {
      formData.append("longitude", location.longitude);
    }
  }
  formData.append("city_id", city_id);
  formData.append("referral_code", referral_code);

  const response = await axios.post(UPDATE_USER, formData);

  return response.data;
};


// get_address

export const get_address = async (addr_id = "") => {

  try {
    const token = getToken();

    if (!token) {
      throw new Error("Authorization token is missing");
    }

    const response = await axios.get(
      GET_ADDRESS,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;



  } catch (error) {
    if (error.response && error.response.status === 401) {
      handleUnauthorizedAccess();
    } else {
      console.error("An error occurred:", error);
    }
    throw error;
  }
};


// add_address

export const add_address = async (
  mobile,
  adds,
  area,
  city,
  landmark,
  latitude,
  longitude,
  address_type = "home"
) => {
  let { id } = getUser();
  const formData = new FormData();
  formData.append("user_id", id);
  formData.append("mobile", mobile);
  formData.append("address", adds);
  formData.append("area", area);
  formData.append("city", city);
  formData.append("landmark", landmark);
  formData.append("latitude", latitude);
  formData.append("longitude", longitude);
  formData.append("type", address_type);

  const response = await axios.post(ADD_ADDRESS, formData);
  return response.data;
};

// delete_address
export const delete_address = async (id) => {
  const formData = new FormData();
  formData.append("id", id);
  const response = await axios.post(DELETE_ADDRESS, formData);
  return response.data;
};

// update_address
export const update_address = async (
  address_id = "",
  mobile = "",
  add = "",
  area = "",
  city = "",
  landmark = ""
) => {
  let { id } = getUser();
  let location = getLatLang();
  const formData = new FormData();
  formData.append("id", address_id);
  formData.append("user_id", id);
  formData.append("mobile", mobile);
  formData.append("address", add);
  formData.append("area", area);
  formData.append("city", city);
  formData.append("landmark", landmark);
  if (typeof location != "undefined") {
    if (typeof location.latitude != "undefined") {
      formData.append("latitude", location.latitude);
    }
    if (typeof location.longitude != "undefined") {
      formData.append("longitude", location.longitude);
    }
  }
  const response = await axios.post(UPDATE_ADDRESS, formData);
  return response.data;
};


export const get_orders = async () => {
  const token = getToken();

  if (!token) {
    throw new Error("Authorization token is missing");
  }

  try {
    const response = await axios.get(
      GET_ORDERS,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized");
      handleUnauthorizedAccess();
      return { error: "Unauthorized" };
    } else {
      console.error("An error occurred:", error);
    }
    throw error;
  }
};

export const search = async ({ keyword, sort, page, type }) => {
  try {
    const response = await axios.get(SEARCH, {
      params: {
        keyword: keyword || "",
        sort: sort || "desc",
        page: page || 1,
        type: type
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};



export const applyCoupon = async (couponCode) => {
  const token = getToken();

  if (!token) {
    throw new Error("Authorization token is missing");
  }

  try {
    const response = await axios.get(`${COUPONS}/${couponCode}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        vendor_type_id: localStorage.getItem("vendor_type_id"),
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Invalid coupon code.");
    }
  } catch (error) {
    console.error("Coupon API Error:", error);

    if (error.response) {
      throw new Error(`${error.response.data.message || "Unknown error"}`);
    } else if (error.request) {
      throw new Error("Network error or no response received.");
    } else {
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};


export const placeOrder = async (data) => {
  const token = getToken();

  if (!token) {
    throw new Error("Authorization token is missing");
  }

  try {
    const response = await axios.post(PLACEORDER, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data; 

  } catch (error) {
    console.error("Place Order API Error:", error);
    if (error.response) {
      throw new Error(error.response.data.message || "Unknown error");
    } else if (error.request) {
      throw new Error("Network error or no response received.");
    } else {
      throw new Error(`Unexpected error: ${error.message}`);
    }
  }
};



